import type {ImportState} from '@gaia/types';
import {useEffect} from 'react';

import {useLatest} from './useLatest';

export function useFitMapToImportEffect(map: mapboxgl.Map | undefined, importState: ImportState) {
    const bounds = importState.status === 'selecting' && importState.bounds;

    const latest = useLatest({importState, map});

    useEffect(() => {
        if (
            latest.current.importState.status === 'selecting' &&
            latest.current.importState.bounds &&
            latest.current.map
        ) {
            try {
                latest.current.map.fitBounds(
                    [
                        [
                            latest.current.importState.bounds[0],
                            latest.current.importState.bounds[1],
                        ],
                        [
                            latest.current.importState.bounds[2],
                            latest.current.importState.bounds[3],
                        ],
                    ],
                    {padding: 100, duration: 250, maxZoom: 14}
                );
            } catch (e) {
                console.error(
                    `useFitMapToImportEffect: Error fitting map to bounds`,
                    JSON.stringify(latest.current.importState)
                );
            }
        }
    }, [latest, bounds]);
}
